import requestManager from '../../../api/requestManager';

const getDashboardDetail = (syndicateId: string) =>
  requestManager.apiGet(`/v1/syndicates/get_dashboard_page_details/?id=${syndicateId}`);

export default {
  getDashboardDetail
};
